import { Check } from 'lucide-react';
import { Link } from 'react-router';

interface ConnectionSuccessSectionProps {
  children?: React.ReactNode;
  hideSuccessText?: boolean;
}

const ConnectionSuccessSection = ({ children, hideSuccessText }: ConnectionSuccessSectionProps) => {
  return (
    <div className="flex flex-col gap-2 justify-center items-center p-4 space-y-4">
      {!hideSuccessText && (
        <span className="text-sm md:text-base font-medium flex items-center gap-2">
          Account successfully connected. <Check className="text-green-500" />
        </span>
      )}
      <div className="flex items-center gap-3">
        <Link
          className="text-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-hidden focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 border border-input bg-background shadow-xs hover:bg-accent hover:text-accent-foreground h-9 px-4 py-2"
          to="/team/connections"
          aria-label="Go Back"
        >
          Go back to connections
        </Link>
        {children}
      </div>
    </div>
  );
};

export default ConnectionSuccessSection;
